import axios from "axios";
import { Message } from '@arco-design/web-vue';
import md5 from "js-md5";

const service = axios.create({
    baseURL: process.env.NODE_ENV === "development" ? '/api' : 'http://49.234.8.207/home',
    timeout: 10000
})
service.interceptors.request.use(
    config => {
        let headers = {
            time: parseInt(Date.now() / 1000),
            nonce: randomString(7),
            appid: "s0f54da89689f24b6b",
            secret: "cc6ca45d6970fda89689f24b6fab2f499b",
        }
        //获取参数
        let data = config.data, params = "", signature = ""
        // 循环拼接参数
        // 提取键并对它们进行排序
        let sortedKeys = []
        if (data) {
            sortedKeys = Object.keys(data).sort();
        }

// 使用排序后的键来创建一个新的对象
        let sortedData = {};
        sortedKeys.forEach(key => {
            sortedData[key] = data[key];
        });
        for (let key in sortedData) {
            if (sortedData[key]!=null&&sortedData[key]!=undefined) {
                params += `${key}=${sortedData[key]}&`
            }
        }

        // 签名
        signature = md5(`${params}appid=${headers.appid}&nonce=${headers.nonce}&time=${headers.time}&secret=${headers.secret}`);
        // 设置请求 headers值
        config.headers.time = headers.time;
        config.headers.nonce = headers.nonce;
        config.headers.appid = headers.appid;
        config.headers.signature = signature;
        config.headers['Authorization'] = `Bearer ${localStorage.getItem('m-token')}`
        return config
    },
    error => {
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code !== 200) {
            if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
                location.href = '/login'
            }
            return Promise.reject(res)
        } else {
            return res
        }
    },
    error => {
        console.log('reject') // for debug
        Message.error(error.message)
        return Promise.reject(error)
    }
)

function randomString(len, charSet) {
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for (let i = 0; i < len; i++) {
        let randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return randomString;
}

export default  service